const getters = {
    isPC: state => state.system.isPC,
    isPad: state => state.system.isPad,
    isMobile: state => state.system.isMobile,
    isFirst: state => state.system.isFirst,
    currentWidth: state => state.system.currentWidth,
    showOrientation: state => state.system.showOrientation,
    units: state => state.studentProgramme.units,
    login: state => state.login.toPath,
    programmeBuyNow: state => state.programme.programmeBuyNow,
    isBuyNow: state => state.programme.isBuyNow,
    active: state => state.cart.active,
    carts: state => state.cart.carts,
    stripe: state => state.cart.stripe,
    language: state => state.lang.language,
    currentGradeId: state => state.studentProgramme.currentGradeId,
    studentCodesId: state => state.cart.studentCodesId,
}
export default getters